"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
class Quote {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Quote = Quote;
//# sourceMappingURL=Quote.js.map